<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>气象设备列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.addr_id" placeholder="输入地址编号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.memo" placeholder="输入备注"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="formInline.phone" placeholder="输入手机号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="info" icon="el-icon-edit" @click="batchEdit()">编辑</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="warning" icon="el-icon-right" @click="moveDevice()">移动</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                  element-loading-text="拼命加载中" style="width: 100%;" ref="generalWeatherTable">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column sortable prop="id" label="ID" width="60" show-overflow-tooltip></el-table-column>
            <el-table-column prop="addr_id" label="地址编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="memo" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phone" label="手机号" show-overflow-tooltip></el-table-column>
            <el-table-column sortable prop="add_time1" label="添加时间" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteCourses(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="地址编码" prop="addr_id">
                    <el-input size="small" v-model="editForm.addr_id" auto-complete="off"
                              placeholder="地址编码"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="memo">
                    <el-input size="small" v-model="editForm.memo" auto-complete="off"
                              placeholder="备注"></el-input>
                </el-form-item>
                <el-form-item label="用户" prop="uid">
                    <el-select v-model="uids" placeholder="请选择">
                        <el-option v-for="item in managers" :key="item.id" :label="item.memo"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

        <!--批量编辑备注-->
        <el-dialog title="批量编辑备注" :visible.sync="showEdit" width="30%" @click="closeMemoDialog('editMemoForm')">
            <el-form label-width="120px" :model="editMemoForm" :rules="rules" ref="editMemoForm">
                <el-form-item label="备注信息" prop="title">
                    <el-input size="small" v-model="editMemoForm.memo" auto-complete="off"
                              placeholder="请填写备注信息"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeMemoDialog('editMemoForm')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitMemoForm('editMemoForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>

        <!--批量移动设备-->
        <el-dialog title="批量移动设备" :visible.sync="showMove" width="30%" @click="closeMoveDialog('editMoveForm')">
            <el-form label-width="120px" :model="editMoveForm" :rules="rules" ref="editMoveForm">
                <el-form-item label="管理员" prop="id">
                    <el-select v-model="editMoveForm.id" placeholder="请选择">
                        <el-option v-for="item in managers" :key="item.id" :label="item.memo"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeMoveDialog('editMoveForm')">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title"
                           @click="submitMoveForm('editMoveForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    import {allWhite, deleteWeather, saveWeather, saveWeatherMemo, saveWeatherMove, weather} from "../../api/userMG";

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                showEdit: false,
                showMove: false,
                title: '添加/修改气象设备',
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                    memo: '',
                    phone: '',
                    add_id: ''
                },
                editForm: {
                    addr_id: '',
                    memo: '',
                    phone: '',
                },
                editMemoForm: {
                    memo: '',
                },
                editMoveForm: {
                    id: '',
                },
                rules: {
                    phone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'}
                    ],
                    memo: [
                        {required: true, message: '请输入备注', trigger: 'blur'}
                    ],
                    add_id: [
                        {required: true, message: '请输入地址编码', trigger: 'blur'}
                    ],
                },
                listData: [], //用户数据
                managers: [],
                uids: [],
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 创建完毕
         */
        created() {
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata(parameter) {
                this.loading = true
                weather(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false

                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.total
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.formInline.pageSize = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
            // 编辑备注
            submitMemoForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let params = {id: this.selectedId, memo: this.editMemoForm.memo}
                        saveWeatherMemo(params)
                            .then(res => {
                                this.showEdit = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.editMemoForm.memo = ''
                                    this.editMemoForm.memo = ''
                                    this.getdata(this.formInline)
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.showEdit = false
                                this.loading = false
                                this.$message.error('备注保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 移动设备
            submitMoveForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let params = {id: this.selectedId, mid: this.editMoveForm.id}
                        saveWeatherMove(params)
                            .then(res => {
                                this.showMove = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.getdata(this.formInline)
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.showEdit = false
                                this.loading = false
                                this.$message.error('备注保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            batchEdit() {
                let selectedRows = this.$refs.generalWeatherTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                this.showEdit = true;
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                this.selectedId = ids
            },
            getManagers() {
                allWhite().then(res => {
                    if (res.code == 200) {
                        this.managers = res.data
                    }
                })
            },
            moveDevice() {
                let selectedRows = this.$refs.generalWeatherTable.selection
                if (selectedRows.length == 0) {
                    this.$message.error('请先选择设备！')
                    return false;
                }
                this.showMove = true;
                let ids = []
                selectedRows.forEach(item => {
                    ids.push(item.id)
                })
                this.selectedId = ids
                this.getManagers()
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                this.getManagers()
                if (row != undefined) {
                    this.editForm = row
                    this.uids = row.m_id
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let row = this.editForm
                        let params = {id: row.id, addr_id: row.addr_id, memo: row.memo, uid: this.uids}
                        saveWeather(params)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.getdata()
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('教程保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除管理员
            deleteCourses(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteWeather({id: row.id})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '教程已删除!'
                                })
                                this.getdata(this.formInline)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '教程删除失败!'
                                })
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('教程删除失败，请稍后再试！')
                        })
                })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 关闭编辑、增加弹出框
            closeOperator() {
                this.operatorVisible = false
            },
            // 关闭编辑、增加弹出框
            closeDialog(formName) {
                this.editFormVisible = false
                this.$refs[formName].resetFields()
            },
            closeMemoDialog(formName) {
                this.showEdit = false
                this.$refs[formName].resetFields()
            },
            closeMoveDialog(formName) {
                this.showMove = false
                this.$refs[formName].resetFields()
            }
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>







// WEBPACK FOOTER //
// src/views/weatherDevice/weatherDevice.vue